const _cache = new Map();

export function cacheGet(key) {
  const hit = _cache.get(key);
  if (!hit) return null;
  if (Date.now() > hit.expiresAt) { _cache.delete(key); return null; }
  return hit.data;
}

export function cacheSet(key, data, ttlMs = 60_000) {
  _cache.set(key, { data, expiresAt: Date.now() + ttlMs });
}

export function cacheInvalidate(prefix) {
  for (const k of _cache.keys()) {
    if (k.startsWith(prefix)) _cache.delete(k);
  }
}
